import useStore from "hooks/useStore";
import useUtils from "hooks/useUtils";
import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AGE_GROUPS } from "utils/helpers/enums/shared.enum";
import { EventsFilterDTO } from "utils/helpers/models/host-dtos/events-filter.dto";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (drawerFilters: any) => void;
  currentFilters?: any; // Track applied filters for sync
}

const FilterDrawer: React.FC<DrawerProps> = ({ isOpen, onClose, onApply, currentFilters = {} }) => {
  const navigate = useNavigate();
  const { getUserCurrentRole } = useStore();

  const userRole = getUserCurrentRole();
  const [selectedFilters, setSelectedFilters] = useState({
    ageGroups: currentFilters.ageGroups || '',
    isSession: currentFilters.isSession || ''
  });

  // Sync drawer state when currentFilters change
  useEffect(() => {
    setSelectedFilters({
      ageGroups: currentFilters.ageGroups || '',
      isSession: currentFilters.isSession || ''
    });
  }, []);

  const filterData = {
    experienceTypes: [
      { title: 'All', value: '' },
      { title: 'Session', value: 'true' },
      { title: 'Workshop', value: 'false' },
    ],
    ages: [
      { title: "Grades 1-3 (Ages 6-9)", value: AGE_GROUPS.GRADES_1_TO_3 },
      { title: "Grades 4-6 (Ages 9-12)", value: AGE_GROUPS.GRADES_4_TO_6 },
      { title: "Grades 7-8 (Ages 12-14)", value: AGE_GROUPS.GRADES_7_TO_8 },
      { title: "Grades 9-12 (Ages 14-18)", value: AGE_GROUPS.GRADES_9_TO_12 },
    ],
    // experienceCounts: ["1-5", "5-10", "11-15", "15-25", "25-30"],
  };

  const handleSelect = (category: string, value: string) => {
    selectedFilters[category] = value;
    setSelectedFilters({ ...selectedFilters });
  };

  const handleApplyFilters = () => {
    onApply(selectedFilters);
    onClose();
  }

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      style={{ zIndex: 'calc(var(--z-drawer) + 1)' }}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-2/3 sm:w-1/2 md:w-1/3 lg:w-[465px] overflow-y-auto bg-white p-4 sm:p-6 shadow-lg transition-transform duration-300 ease-in-out transform ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>

        <h2 className="text-base sm:text-lg md:text-xl text-black font-semibold mb-4 sm:mb-6">Filter by</h2>
        <div className="space-y-4 sm:space-y-6">
          {/* Experience Type */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold text-darkBlueText mb-3 sm:mb-4">
              Experience Type
            </h3>
            <div className="flex flex-wrap gap-2">
              {filterData.experienceTypes.map((type, index) => (
                <button
                  key={index}
                  className={`px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base rounded-full flex items-center gap-2 ${selectedFilters.isSession === type.value
                    ? "bg-primaryBlueText text-white"
                    : "bg-fade text-primaryBlueText"
                    }`}
                >
                  <span onClick={() => handleSelect("isSession", type.value)}>
                    {type.title}
                  </span>
                  {(selectedFilters.isSession === type.value && type.value !== '') && <FaTimes onClick={() => handleSelect("isSession", '')} />}
                </button>
              ))}
            </div>
          </div>

          {/* Age */}
          {/* {
            userRole !== 'CHILD' && (


              <div>
                <h3 className="text-sm sm:text-base font-semibold text-darkBlueText mb-3 sm:mb-4">Age</h3>
                <div className="flex flex-wrap gap-2">
                  {filterData.ages.map((age, index) => (
                    <button
                      key={index}
                      className={`px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base rounded-full flex items-center gap-2 ${selectedFilters.ageGroups === age.value
                        ? "bg-primaryBlueText text-white"
                        : "bg-fade text-primaryBlueText"
                        }`}
                    >
                      <span onClick={() => handleSelect("ageGroups", age.value)}>
                        {age.title}
                      </span>
                      {selectedFilters.ageGroups === age.value && <FaTimes onClick={() => handleSelect('ageGroups', '')} />}
                    </button>
                  ))}
                </div>
              </div>
            )
          } */}
        </div>

        <div className="mt-4 sm:mt-6">
          <button className="w-full h-[46px] sm:h-[64px] text-sm sm:text-base md:text-lg bg-primaryBlueText text-white rounded-full font-medium" onClick={handleApplyFilters}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterDrawer;